<script setup lang="ts">
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { AIRPORT, REGION, SUB_REGION } from '@/constants';
import RadioButton from 'primevue/radiobutton';

interface Props {
  referenceType: string;
}
const props = defineProps<Props>();

const emits = defineEmits<{ 'update:referenceType': [value: any] }>();

const { t } = useI18n({ useScope: 'global' });

const referenceTypeData = computed({
  get() {
    return props.referenceType;
  },
  set(value) {
    emits('update:referenceType', value);
  }
});

const cityType = ref([
  {
    label: t('common.airport'),
    type: AIRPORT
  },
  {
    label: t('common.region'),
    type: REGION
  },
  {
    label: t('common.sub_region'),
    type: SUB_REGION
  }
]);
</script>

<template>
  <div>
    <div class="type-view flex justify-content-between">
      <div v-for="(type, index) in cityType" :key="index" class="mr-3">
        <RadioButton :id="type.label" v-model="referenceTypeData" :value="type.type" />
        <label :for="type.label" class="ml-1">{{ type.label }}</label>
      </div>
    </div>
  </div>
</template>
